// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--749bd";
export var container = "styles-module--container--62a94";
export var desktopImage = "styles-module--desktop-image--b61d4";
export var hoverImage = "styles-module--hover-image--f0c06";
export var imageContainer = "styles-module--image-container--24f8c";
export var mobileImage = "styles-module--mobile-image--53945";